import React from 'react'
import { IconType } from 'react-icons'
import { useTheme } from '../../hooks/useTheme'
import styles from './EmptyState.module.scss'

interface Props {
  icon: IconType
  title: string
  description?: string
}

export const EmptyState = ({ icon: Icon, title, description }: Props) => {
  const { theme } = useTheme()
  
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <Icon size={48} color={theme.primary} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      {description && (
        <p className={styles.description}>{description}</p>
      )}
    </div>
  )
}